module.exports = __webpack_public_path__ + "static/media/female_front_grey.781dd38c.png";